import { config } from '../config';

export const formatCurrency = function (amount: number) {
  const options = {
    style: 'currency',
    currency: config.general.currencyISOCountryCode,
  };
  const numberFormat = new Intl.NumberFormat(
    config.general.ISOLanguageCode,
    options,
  );
  return numberFormat.format(amount);
};

export const formatDate = function (date: Date) {
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
    timeZone: config.general.TimeZone,
  };
  // @ts-ignore
  return new Intl.DateTimeFormat('es', options).format(new Date(date));
};

export const formatDateWide = function (date: Date) {
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: config.general.TimeZone,
  };
  // @ts-ignore
  return new Intl.DateTimeFormat('es', options).format(new Date(date));
};

export const formatShortDate = function (date: Date) {
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour12: false,
    timeZone: config.general.TimeZone,
  };
  // @ts-ignore
  return new Intl.DateTimeFormat('es', options).format(new Date(date));
};
